<mat-card
  appearance="outlined"
  class="committee-subcard {{
    milestone.name.split(' ').join('-').toLowerCase()
  }}"
  >
  <mat-card-title>
    <div class="subcard-title row space-between">
      <h3 class="col-9">{{ milestone.name }}{{ getMilestoneDate() }}</h3>
      <div class="col-2 toggle-container">
        <button
          type="button"
          class="collapse-button {{ isCollapsed ? 'expand' : 'collapse' }}"
          (click)="isCollapsed = !isCollapsed"
          >
          <mat-icon>expand_more</mat-icon>
        </button>
      </div>
    </div>
  </mat-card-title>
  <div class="template-wrapper">
  </div>
  <mat-card-content class="{{ isCollapsed ? 'collapse' : 'expand' }}">
    <committee-votes
      [voteTypes]="milestone.committeeVoteTypes ?? []"
      [votes]="project.committeeVotes ?? []"
      [projectId]="project.id"
      [milestoneId]="milestone.id"
      [milestoneName]="milestone.name"
      [projectDates]="pipelineProjectDates"
      [readOnly]="readOnly"
      >
    </committee-votes>
    @if (milestone.name.toLowerCase()!=='closed') {
      <hr />
    }
    <app-committee-approvals
      [approvalTypes]="approvalTypes"
      [milestoneId]="milestone.id"
      [projectId]="project.id"
      [milestoneApprovalTypes]="milestone.committeeApprovalTypes ?? []"
      [milestoneName]="milestone.name"
      [project]="project"
      [readOnly]="readOnly"
    ></app-committee-approvals>
    @if (milestone.name.toLowerCase() !== 'closed') {
      <app-committee-conditions
        [projectId]="project.id"
        [isCompletedConditions]="true"
        [milestones]="milestones"
        [milestone]="milestone"
        [approvalType]="itemsService.getLegalApprovalType()"
        [title]="'CLEARED CONDITIONS'"
        [readOnly]="readOnly"
        >
      </app-committee-conditions>
    }
  </mat-card-content>
</mat-card>
